<div class="mobile-adapter">
    <div class="mobile-view">
        <div class="mobile-box">
            <div class="text-align-center">
                <img class="app-logo" src="assets/img/trainingym-logo.svg" alt="logo" />
                <ion-card class="login-card max-512 margin-top-32">
                    <ion-card-content>
                        <div class="display-flex column gap-16">
                            <ion-item>
                                <ion-input type="text" [placeholder]="'user' | translate" [(ngModel)]="credentials.nickname"></ion-input>
                                <ion-icon name="person"></ion-icon>
                            </ion-item>
                            <ion-item>
                                <ion-input [type]="typePassword" [placeholder]="'password' | translate" [(ngModel)]="credentials.password"></ion-input>
                                <ion-icon [name]="isVisiblePassword ? 'eye-off' : 'eye'" slot="end" (click)="togglePassword()" style="margin: 0;"></ion-icon>
                            </ion-item>
                            <div class="show_pass">
                                <a (click)="goToRecovery()">{{ 'recover_password' | translate }}</a>
                            </div>
                        </div>
                        <ion-button expand="block" class="branding-1" [disabled]="isLoading" (click)="submit()">
                            {{ 'iniciar_sesion' | translate }}
                        </ion-button>
                    </ion-card-content>
                </ion-card>
                <div class="display-flex column justify-center align-center gap-16 max-512 margin-top-32">
                    <p class="terms ion-text-center">
                        ©2015–{{currentYear}} All Rights Reserved. Trainingym® is a registered trademark of The Intelinova
                        Software S.L. <a href="https://trainingym.com/politica-de-cookies/" target="_blank" rel="noopener">Cookie Preferences</a>, 
                        <a href="https://trainingym.com/politica-de-privacidad/" target="_blank" rel="noopener">Privacy</a>, and 
                        <a href="https://trainingym.com/aviso-legal/" target="_blank" rel="noopener">Terms</a>.
                    </p>

                    <img class="ue" src="assets/img/login/ue.svg" alt="logo" />
                </div>
            </div>
        </div>
    </div>
</div>